import type { RepoPolicyWire } from '@developerz/domain';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { formatLintError } from '../lib/policyLint';

// Policy tab → a BROKEN snapshot (#3911). Presenter.
//
// The API resolved the repo's `.maintainer.yml` snapshot, it failed, and the
// platform is running `defaultPolicy` instead; the tab renders those defaults
// below this alert. Every failing path comes from that same resolve
// (`resolvePolicy`, server-side) — the client computes no validity of its own.

export function PolicyFallbackAlert(props: {
  readonly fallback: NonNullable<RepoPolicyWire['fallback']>;
}): JSX.Element {
  return (
    <div class="alert alert--destructive" role="alert">
      <p class="alert__title">{t('repo_detail.policy_fallback_title')}</p>
      <p class="alert__desc">
        {t(
          props.fallback.stage === 'shape'
            ? 'repo_detail.policy_fallback_shape'
            : 'repo_detail.policy_fallback_semantic',
        )}
      </p>
      <ul class="repo-policy__errors">
        <For each={props.fallback.errors}>{(e) => <li>{formatLintError(e)}</li>}</For>
      </ul>
      <p class="alert__desc">{t('repo_detail.policy_fallback_defaults')}</p>
    </div>
  );
}
